module.exports = __webpack_public_path__ + "img/image2.d9a45018.png";